import React, { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Button } from '../../atoms';
import cn from 'classnames';
import styles from './LandscapeAboutContactPersonsTemplate.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import LandscapeBaseEditTemplate from '../../../templates/LandscapeBaseEditTemplate';
import { Container } from 'react-bootstrap';
import LandscapeAboutBaseEditTemplate from '../../../templates/LandscapeAboutBaseEditTemplate';
import { LandscapeContactPersonResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-contact-person-response.dto';
import { LandscapeAboutContactPersonsOrganism } from '../../organisms';

interface LandscapeAboutContactPersonsTemplateProps {
  contactPersons: LandscapeContactPersonResponseDto[];
  handleEdit: (id: string) => void;
  handleDelete: (id: string) => void;
}

const LandscapeAboutContactPersonsTemplate: FC<
  LandscapeAboutContactPersonsTemplateProps
> = ({ contactPersons, handleEdit, handleDelete }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <BaseTemplate>
      <Container>
        <LandscapeBaseEditTemplate>
          <LandscapeAboutBaseEditTemplate>
            <div className={cn(styles.landscapeAboutContactPersonsWrapper)}>
              <div className={cn(styles.button)}>
                <Button
                  variant="dark"
                  onClick={() =>
                    navigate(`/landscapes/edit/${id}/about/contact-person/add`)
                  }
                >
                  Add Contact Person
                </Button>
              </div>
              <div className={cn(styles.tableWrapper)}>
                <LandscapeAboutContactPersonsOrganism
                  contactPersons={contactPersons}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                />
              </div>
            </div>
          </LandscapeAboutBaseEditTemplate>
        </LandscapeBaseEditTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeAboutContactPersonsTemplate;
